import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import NarrativeEventContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/NarrativeEventContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from "../../../analytics/TrackString";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DialogPlayerRegisterEvent from "../../../ngt/dialog/controller/DialogPlayerRegisterEvent";
import NGTDialogFactory from "../../../ngt/dialog/NGTDialogFactory";
import NGTDialogPlayer from "../../../ngt/dialog/NGTDialogPlayer";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";

export default class PlayNonInteractiveConversationCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {NGTDialogFactory} dialogFactory 
     * @param {NGTDialogPlayer} dialogPlayer
     */
    constructor(dispatcher, dialogFactory, dialogPlayer) {
        super(dispatcher);

        this._dialogFactory = dialogFactory;
        this._dialogPlayer = dialogPlayer;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
    }

    async execute(event) {
        /** @type {NarrativeEventContent} */
        const content = event.params.data.content;
        this._dialogPlayer.setContentPlayer(event.params.data.contentPlayer);
        this._dialogPlayer.setContent(content);

        const dialogId = content.getEventName();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog start
        this.trackEvent(TrackString.EVENT_DIALOG_START, TrackString.createDialogParams(dialogId));

        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound, this);

        this._dialogPlayerSkin = this.openScreen(SkinKeyRegistry.NON_INTERACTIVE_CONVERSATION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            dialogPlayer: this._dialogPlayer,
        });

        this._startTime = Date.now();
    }

    _handleContentCompleted({ params }) {
        /** @type {NarrativeEventContent} */
        const content = params.data.content;
        if (content !== this._dialogPlayer.getContent()) {
            return;
        }

        this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

        const dialogId = content.getEventName();
        const dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
        this.dispatch(dprEvent.type, dprEvent);

        // Analytics: Sends dialog end
        this.trackEvent(TrackString.EVENT_DIALOG_END, TrackString.createDialogParams(dialogId));

        // Close the content.
        this.closeScreen(this._dialogPlayerSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this.destroy();
    }

    destroy() {
        this._dialogPlayer.destroy();
        this._dialogPlayer = null;
        this._dialogPlayerSkin = null;
    }
}